import React, { useEffect } from 'react';
import { X } from 'lucide-react';

export function Modal({ title, onClose, children, width = 'max-w-lg' }) {
  useEffect(() => {
    const fn = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', fn);
    return () => document.removeEventListener('keydown', fn);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fade-in"
      style={{ background: 'var(--overlay)', backdropFilter: 'blur(2px)', WebkitBackdropFilter: 'blur(2px)' }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        className={`rounded-[24px] w-full ${width} animate-slide-up`}
        style={{ background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', boxShadow: 'var(--modal-shadow)', maxHeight: 'calc(100vh - 32px)', display: 'flex', flexDirection: 'column' }}
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
      >
        <div className="flex items-center justify-between px-6 py-4" style={{ borderBottom: '1px solid var(--border-soft)', flexShrink: 0 }}>
          <h2 className="text-lg font-semibold th-text">{title}</h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="modal-close w-8 h-8 rounded-[10px] flex items-center justify-center transition-colors"
          >
            <X size={15} />
          </button>
        </div>
        {/* Long content scrolls inside the dialog, so its buttons are never off-screen */}
        <div className="px-6 py-5" style={{ overflowY: 'auto', minHeight: 0 }}>{children}</div>
      </div>
    </div>
  );
}